import React, { Component } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import $ from "jquery";
import "./App.scss";
import "./Global";

import "antd/dist/antd.css";
import "./styles/bootstrap.scss";
import "filepond/dist/filepond.min.css";

import "./styles/app.scss";
import "./App.scss";
import "./Vendor";
// import "./resources/Titillium_Web/TitilliumWeb-Black.ttf";
// import "./resources/fontelloori/css/myicon.css";
// import "./resources/fontello/css/seacargo-go.css";
// import "./resources/Titillium_Web/TitilliumWeb-Bold.ttf";
import { store, persistor } from "./state/store/";
import LoginComponent from "./components/OBL/Login";
import RecoverPasswors from "./components/OBL/RecoverPassword";
import HomeComponent from "./components/OBL/Home";
import Admin from "./components/OBL/Admin";
import Trazabilidad from "./components/OBL/Trazabilidad";
import QuickSearch from "./components/OBL/QuickSearch";
import shipmentsDetailComponent from "./components/OBL/Trazabilidad/Embarques/ShipmentsDetail";
import WrapperRoute from "./components/Middlewares/WrapperRoute";
import NotFound from "./components/template/pages/notFound";
import Politicas from "./pages/politica_privacidad";
import terminos_condiciones from "./pages/terminos_condiciones";
import Finance from "./components/OBL/Finance";
import Reports from "./components/OBL/Reports/index";
import MyReportsCreate from "./components/OBL/Reports/MyReports/Create";
import Tools from "./components/OBL/LogisticsTools";
import Alerts from "./components/OBL/Alerts";
import InfoAlerta from "./components/OBL/Alerts/info";
import Documents from "./components/OBL/Documents";

import AltaUsuario from "./components/OBL/Admin/createuser/index";
import GoAnalytics from "./components/OBL/MyAnalitics/goanalytics";

/* Service Desk */

import ServiceDesk from "./components/OBL/servicedeskmodule";
import TicketDetail from "./components/OBL/servicedeskmodule/app/TicketDetails";

import InTransit from "./components/OBL/InTransit";
import warehouseReceiveDetailComponent from "./components/OBL/InTransit/Embarques/ReceiveDetail";
import warehouseDipatchDetailComponent from "./components/OBL/InTransit/Embarques/DispatchDetail";

import history from "./history";
import { moduleActions } from "./components/Global/Permission/constants";
import axios from "axios";

// Aceptar 304 Not Modified como respuesta válida (Node 22 / navegadores
// modernos devuelven 304 con más frecuencia por el caching del dev server
// y CDNs; axios por defecto solo acepta 2xx y lo trata como error).
axios.defaults.validateStatus = (status) => status < 400;

$.ajaxPrefilter((o) => (o.async = true));

/*=============================================
=            App Component With Router        =
=============================================*/

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "ES",
    };
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter history={history} basename={"/"}>
            <Switch>
              <Route exact path="/" component={LoginComponent}></Route>

              <Route
                exact
                path="/dashboard"
                render={() => (
                  <WrapperRoute
                    name={"dashboard"}
                    component={HomeComponent}
                  ></WrapperRoute>
                )}
              ></Route>

              <Route
                exact
                path="/admin"
                render={() => (
                  <WrapperRoute
                    name={"Admin"}
                    moduleAction={moduleActions.ADMIN_VISUALIZAR}
                    component={Admin}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/terminos-y-condiciones"
                component={terminos_condiciones}
              />
              <Route exact path="/politicas_privacidad" component={Politicas} />
              <Route
                exact
                path="/trazabilidad"
                render={() => (
                  <WrapperRoute
                    name={"Trazabilidad"}
                    component={Trazabilidad}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/altausuario"
                render={() => (
                  <WrapperRoute
                    name={"alta_usuarios"}
                    moduleAction={moduleActions.ADMIN_USUARIO_ALTA}
                    component={AltaUsuario}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/obl-analytics"
                render={() => (
                  <WrapperRoute
                    name={"oblanalytics"}
                    component={GoAnalytics}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/finanzas"
                render={() => (
                  <WrapperRoute
                    name={"finance"}
                    component={Finance}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/reports"
                render={() => (
                  <WrapperRoute
                    name={"reports"}
                    component={Reports}
                  ></WrapperRoute>
                )}
              ></Route>
              <Route
                exact
                path="/reportes-especiales/creacion"
                render={() => (
                  <WrapperRoute
                    name={"myreports_create"}
                    component={MyReportsCreate}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/tools"
                render={() => (
                  <WrapperRoute
                    name={"logistics_tools"}
                    component={Tools}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/alerts-and-notifications"
                render={() => (
                  <WrapperRoute
                    name={"alert_notification"}
                    component={Alerts}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/documents"
                render={() => (
                  <WrapperRoute
                    name={"documents"}
                    component={Documents}
                  ></WrapperRoute>
                )}
              />

              {/* Routes with params */}

              <Route
                exact
                path="/shipmentsDetail/:id"
                render={() => (
                  <WrapperRoute
                    name={"shipmentsDetails"}
                    filterCustomer={moduleActions.SHIPMENT_DETALLE}
                    component={shipmentsDetailComponent}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/altausuario/:id"
                render={() => (
                  <WrapperRoute
                    name={"alta_usuarios"}
                    moduleAction={moduleActions.ADMIN_USUARIO_EDITAR}
                    component={AltaUsuario}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/search/:id*"
                render={() => (
                  <WrapperRoute
                    name={"quick_search"}
                    component={QuickSearch}
                  ></WrapperRoute>
                )}
              />
              <Route
                exact
                path="/infoAlert/:id"
                render={() => (
                  <WrapperRoute
                    name={"info_alerta"}
                    moduleAction={moduleActions.ADMIN_ALERTA_EDITAR}
                    component={InfoAlerta}
                  ></WrapperRoute>
                )}
              />

              {/* Service Desk Module */}
              <Route
                exact
                path="/service-desk"
                render={() => (
                  <WrapperRoute name={"service-desk"} component={ServiceDesk} />
                )}
              />
              <Route
                exact
                path="/ticket-detail/:id"
                render={() => (
                  <WrapperRoute
                    name={"TicketDetails"}
                    component={TicketDetail}
                  />
                )}
              />

              {/* In Transit Module */}
              <Route
                exact
                path="/warehousing"
                render={() => (
                  <WrapperRoute
                    name={"InTransit"}
                    component={InTransit}
                  ></WrapperRoute>
                )}
              ></Route>

              {/* In Transit Module */}
              <Route
                exact
                path="/warehousingDetail/receive/:id"
                render={() => (
                  <WrapperRoute
                    name={"InTransit"}
                    component={warehouseReceiveDetailComponent}
                  ></WrapperRoute>
                )}
              ></Route>

              <Route
                exact
                path="/warehousingDetail/dispatch/:id"
                render={() => (
                  <WrapperRoute
                    name={"InTransit"}
                    component={warehouseDipatchDetailComponent}
                  ></WrapperRoute>
                )}
              ></Route>

              <Route
                exact
                path="/recoverpassword/:token"
                component={RecoverPasswors}
              ></Route>

              <Route component={NotFound} />
            </Switch>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
